import React, { CSSProperties } from 'react';

export const Logo = ({ uri }: { uri: string }) => {
  const imageStyle: CSSProperties = {
    width: '150px',
    height: '150px',
  };

  return <img src={uri} alt="Logo" style={imageStyle} />;
};
